<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-configurations">
    <el-tabs v-model="activeTab" tab-position="left">
      <el-tab-pane name="globalConfigurationTab" label="Global Configuration">
        <wy-configurations-global-configuration ref="globalConfiguration"/>
      </el-tab-pane>
      <el-tab-pane name="companyConfigurationTab" label="Company Configuration">
        <wy-configurations-company-configuration ref="companyConfiguration"/>
      </el-tab-pane>
      <!-- <el-tab-pane name="mockApiTab" label="Mock APIs">
        <wy-configurations-mock-api ref="mockApi"/>
      </el-tab-pane> -->
      <el-tab-pane name="settingsSystem" label="System Settings">
        <wy-configurations-system ref="settingsSystem" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import WyConfigurationsGlobalConfiguration from './wy-configurations-global-configuration';
import WyConfigurationsCompanyConfiguration from './wy-configurations-company-configuration';
import WyConfigurationsSystem from './wy-configurations-system';

export default {
  name: 'wy-configurations',
  modalTitle: 'Configurations',

  components: { 
    'wy-configurations-global-configuration': WyConfigurationsGlobalConfiguration,
    'wy-configurations-company-configuration': WyConfigurationsCompanyConfiguration,
    'wy-configurations-system': WyConfigurationsSystem,
  },
  
  data() {
    return {
      controller: this,
      activeTab: 'globalConfigurationTab'
    };
  }
};
</script>

<style lang="scss">
.wy-configurations {
  height: 100%;
  .el-tabs, .el-tabs__header, .el-tabs__nav-wrap, .el-tabs__nav-scroll, .el-tabs__nav {
    height: 100%;    
  }

  .el-tabs__content {
    box-sizing: border-box;
    padding: 20px;
    height: 100%;
  }

  .el-tabs__item {
    color: var(--site-font-primary-color);
  }

  #pane-globalConfigurationTab {
    height: 100%;
  }

  #pane-companyConfigurationTab {
    height: 100%;
  }

  #pane-mockApiTab {
    height: 100%;
  }

  .el-tabs__item.is-active {
    background-color: #E2ECF7;
  }
  .el-tabs__active-bar {
    background-color: #214586;
    width: 6px !important;
  }
}
</style>